import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NEVER, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MaintenanceStateService } from '../maintenance-state/maintenance-state.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  constructor(private maintenanceState: MaintenanceStateService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 503 && error.error?.maintenance) {
          this.maintenanceState.turnOnMaintenanceMode();
          return NEVER;
        }

        return throwError(() => error);
      })
    );
  }
}
